// Where to land after login: the page that sent the user to log in, if one did.
// Logout can record /login itself as that page (react-admin's checkAuth logs out a
// second time once the user is already there), and returning to it would leave the
// user stuck on the login form, so it falls back to the home page instead.
const afterLoginPath = (location) => {
  const { nextPathname, nextSearch } = location?.state || {}
  if (!nextPathname || nextPathname === '/login') return '/'
  return `${nextPathname}${nextSearch ?? ''}`
}

export default afterLoginPath
